import { supabase } from '@/integrations/supabase/client';

/**
 * Resolves the active brand kit ID for the current workspace context.
 *
 * Calls `get_effective_brand_kit()`, the zero-arg authenticated RPC.
 * Returns null if no active kit is configured or the user has none.
 */
export async function resolveActiveBrandKitId(): Promise<string | null> {
  try {
    const { data, error } = await supabase.rpc('get_effective_brand_kit');
    if (error || !Array.isArray(data) || data.length === 0) return null;
    return (data[0] as { id?: string }).id ?? null;
  } catch {
    return null;
  }
}
